import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';
import _ from 'lodash'
import { Oval } from  'react-loader-spinner'



const pageSize =5;
const TecExpertiseMain = () => {
  useEffect(()=>{  
    document.getElementById("PopAAdd").style.display="none"
    document.getElementById("PopATable").style.display="none"
    // getparticularRole()
    getTecExpertise()


    setpop(true);
    setTimeout(() => {
            
      getroleAction() 
      
       }, 1000);
    setTimeout(() => {
            
      setpop(false);
      getAssignedAction()
    
        
       }, 2000);

  }, [])

  const[pop,setpop] = useState(false);

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
     ///getTecExpertise


     const [sectionExpertise, setSectionExpertise] = useState([])
     const [EditSectionExpertise, setEditSectionExpertise] =useState([])

     const [paginatedPosts, setpaginatedPosts] = useState();
     const [currentPage, setcurrentPage] = useState(1);
  function getTecExpertise()
  {

 

  fetch(`${BASE_URL}/Tec/GettecExpertise`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionExpertise(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());

      // if(pageNo==null){
      //   setcurrentPage(1)
      // }
      // else{
      //   pagination(currentPage)
        
      //   // setpaginatedPosts()
      //   //setcurrentPage(pageNo)
      // }
      
       //console.log(pageNo,"checkpageno")
        }
    );



      }


      const pageCount = sectionExpertise? Math.ceil(sectionExpertise.length/pageSize) :0;
// if (pageCount === 1)
// return null;

const pages = _.range(1, pageCount+1)

const pagination =(pageNo)=>{
 
setcurrentPage(pageNo);
const startIndex = (pageNo - 1) * pageSize;
const paginatedPost = _(sectionExpertise).slice(startIndex).take(pageSize).value();
setpaginatedPosts(paginatedPost)
}


const onNext = () => {


  pagination(currentPage + 1);
};

const onPrevious = () => {
  pagination(currentPage - 1);
};


      ///submitsection

   const [fileExpertise, setFileExpertise] = useState();
   const [fileExpertiseImg, setFileExpertiseImg] = useState();
   // console.log(file)
   
   const  handleFileChangeExpertise = (e) => {
    
       setFileExpertise(e.target.files[0]);
       setFileExpertiseImg(URL.createObjectURL(e.target.files[0]));
   };
 
   function submitsectionExpertise(){

    var UserId= localStorage.getItem('UserId')

     var textExpertise = document.getElementById("textExpertise").value;
     var DescriptionExpertise=document.getElementById("DescriptionExpertise").value;
     console.log(textExpertise)

     if(!fileExpertise){

      document.getElementById("AddExpA").innerHTML="image Required"

    }
    else if(fileExpertise){

      document.getElementById("AddExpA").innerHTML=" "

    }
     if(!textExpertise){

       document.getElementById("AddExpB").innerHTML="Heading Required"
       
       
     }
     else if(textExpertise){

       document.getElementById("AddExpB").innerHTML=" "
      
     }

     if(!DescriptionExpertise){

      document.getElementById("AddExpC").innerHTML="Description Required"
     }

     else if(DescriptionExpertise){

      document.getElementById("AddExpC").innerHTML="  "

     }
     
   

     if(textExpertise &&fileExpertise && DescriptionExpertise){



    const body =
     {
       
       Text:textExpertise, 
       Image:fileExpertise,
       Description: DescriptionExpertise,
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId
       
        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecExpertise`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
            //  toast.success("Section Added")
           
            setSuccessToast(true)
             setTimeout(() => {
              setSuccessToast(false)
              getTecExpertise()

              closeExpertiseAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Add") 

     })
       
   }

   }


   
     ////Get Particular Data PostMethod

     const [Edittec, setEdittec] =useState([])
     function SelectParticular(Id){

      const body =
      {
        
       id:Id
      }
      console.log('body',body);
 
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Tec/EdittecExpertise`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  'Authorization':bearer 
              }     
          }) 
          
     
          .then((response) =>{
            console.log(JSON.stringify(response.data));
       
        
            setEditSectionExpertise(response.data)
 
            setEdittec(response.data)
       
         })
         .catch(error => {
           console.log(error);
           
         })
     }

     function editSectionExpertise(Id){
       SelectParticular(Id)

      document.getElementById("ExpertiseEditPop").style.display = "block";
 
    

     }
  //function closeform

  function closeForm(){

    document.getElementById("modaldeleteForm").style.display ="None"
  
  }


     function updateSectionExpertise(Id){

      var UserId= localStorage.getItem('UserId')
       var ImagefileExpertise = document.getElementById("tecimage").src;
       var TextExpertise = document.getElementById("textExpertiseA").value;
       var DescriptionExpertise = document.getElementById("DescriptionExpertiseA").value;



       
       if(!TextExpertise){

         document.getElementById("ExpA").innerHTML="Heading Required"

       }
       else if(TextExpertise){

         document.getElementById("ExpA").innerHTML=" "

       }
       
      
       if(!DescriptionExpertise){

        document.getElementById("ExpB").innerHTML="Description Required"

      }
      else if(DescriptionExpertise){

        document.getElementById("ExpB").innerHTML=" "

      }
      
       if(TextExpertise && DescriptionExpertise){


       



    const body =
     {
       Id:Id,
       Text:TextExpertise, 
       Image:fileExpertise,
       Description:DescriptionExpertise,
       OldImage:ImagefileExpertise,
       EditedBy:UserId

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/UpdatetecExpertise`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){

          closeExpertiseEditForm()
            //  toast.success("Section Updated")
            setUpdateToast(true)
             setTimeout(() => {
              setUpdateToast(false)
              getTecExpertise()
              setcurrentPage(1)
           
             }, 2000);
           }
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Update")   
     })
       
    
   }

     }
  
     function ConfirmDelete(Id){

      SelectParticular(Id)
      setTimeout(() => {
        document.getElementById("modaldeleteForm").style.display = "block";
      },1000);
    
    }

   ///DeleteSectionA

   function DeleteSectionExpertise(Id){

 
     

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/DeletetecExpertise`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        setDeleteErrToast(true)
        
        closeForm()
            //  toast.info("Section Deleted")
           
             setTimeout(() => {
             
              getTecExpertise()
              
              setDeleteErrToast(false)
              setcurrentPage(1)
             }, 2000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed")   
     })
       
    

   

   }




  //OpenAddForm
  function openExpertiseForm(){

    document.getElementById("ExpertiseAddPop").style.display = "block";

  }

  //closeAddForm
  function closeExpertiseAddForm(){


    setFileExpertise();
    setFileExpertiseImg();
 
    document.getElementById("AddExpA").innerHTML=" "
    document.getElementById("AddExpB").innerHTML=" "
    document.getElementById("AddExpC").innerHTML=" "
    document.getElementById("tecformExpertise").reset();
           
   
     document.getElementById("ExpertiseAddPop").style.display = "none";
   
  }
  //closeEditForm
  function closeExpertiseEditForm(){

    setFileExpertise();
    setFileExpertiseImg();
    document.getElementById("ExpA").innerHTML=" "
    document.getElementById("ExpB").innerHTML=" "
    document.getElementById("teceditform").reset();
 
    document.getElementById("ExpertiseEditPop").style.display = "none";
   }
   
  //  var UserId= localStorage.getItem('UserId')
  //  function getparticularRole(){
  
  //    const body =
  //    {
       
  //     id:UserId
  //    }
  //    console.log('body',body);
  
   
  //    axios({
  //           method:"POST",
  //           url :`${BASE_URL}/Tec/Getparticularid`,
  //           data:body, 
  //           headers: {
  //                "Content-type": "application/json",
  //                "Authorization": bearer,
  //            }     
  //        }) 
         
    
  //        .then((response) =>{
  //          console.log(response.data);
      
        
        
                 
  //          localStorage.setItem("LoginRole",JSON.stringify(response.data))
           
  //       })
  //       .catch(error => {
  //         console.log(error);
  //  })
  // }
  function getroleAction(){
  
  
  
   let LoginRole =  localStorage.getItem("Role");
  //  let TecRole =  JSON.parse(LoginRole);
  //  let role = TecRole.map((e)=>e.roleId);
  //  let Role= role[0]
   console.log('checkrole',LoginRole);
   const body =
   {
     
    role:LoginRole
   }
   console.log('body',body);
  
  
   axios({
          method:"POST",
          url :`${BASE_URL}/Tec/GetTecRoleAction`,
          data:body, 
          headers: {
               "Content-type": "application/json",
               "Authorization": bearer,
           }     
       }) 
       
  
       .then((response) =>{
         console.log(response.data);
    
      
      
               
         localStorage.setItem("LoginAction",JSON.stringify(response.data))
         localStorage.getItem("LoginAction");
      })
      .catch(error => {
        console.log(error);
  })
  }
        
  const[editicon,setediticon] = useState(false);
  const[delicon,setdelicon] = useState(false);
  const[denied,setdenied] = useState(false); 
   function getAssignedAction(){
  
  
  
    ////Admin
      let LoginRoleId =  localStorage.getItem("RoleId");
      // let TecRole =  JSON.parse(LoginRole);
      // let role = TecRole.map((e)=>e.roleId);
      // let RoleA =role.toString();
  
      let CheckSAdmin = LoginRoleId.includes("00")
      let CheckAdmin =LoginRoleId.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
      if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopAAdd').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopAAdd').style.display ="block";
      }
      else{
        document.getElementById('PopAAdd').style.display ="none";
  
      }
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopATable').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopATable').style.display ="block";
      }
      else{
        document.getElementById('PopATable').style.display ="none";
  
      }
      if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setediticon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setediticon(true)
      }
      else{
        setediticon(false)
  
      }
      if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setdelicon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setdelicon(true)
      }
      else{
        setdelicon(false)
  
      }

      
    if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){

      setdenied(true)
    }
    else{

      setdenied(false)
    }

    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
      document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
       }
    }
           
    const[SuccessToast,setSuccessToast] = useState(false);  
    const[UpdateToast,setUpdateToast] = useState(false);  
    const[DeleteToast,setDeleteErrToast] = useState(false);


  return (
    <div className='tec-addmain'>
      

        
  {/* <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
  <div className='tec-addmain-back'>
  <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
  </div> 
  <span>Expertise</span>
  </div>
  </div> */}

<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">EXPERTISE</span></span>
 <div className='tec-addmain-back'>
<Link to="/TecIndex"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div></p> 

 {/* <hr></hr> */}
 </div>
    </div>  




    {/* Toast */}
    {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null} 

  <div className='tec-addmain-add'  id="PopAAdd">
   <button className='add-user' onClick={openExpertiseForm}>Add Expertise</button>
   </div>   

  <div>
    

         {/* EditFirst */}
 <div className='tech-pop-fade' id="ExpertiseEditPop">
{EditSectionExpertise.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"70px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT EXPERTISE</h4>
        <button type="button" className="close" onClick={closeExpertiseEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionExpertise(e.id,currentPage)}>
      <div className="modal-body mx-3">
      <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
        {/* <label id="sectionlable">Image</label> */}
      
         <input type="file" onChange={handleFileChangeExpertise} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}}  />
         {!fileExpertiseImg?<img id="tecimage" src={e.image}  /> : <img id="tecimage" src={fileExpertiseImg}  /> }
         <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
        </div>
        <div className="md-form mb-5">
        <label id="sectionlable">Heading</label> 
          <input type="text" id="textExpertiseA"  defaultValue={e.text}/>
          <span id="ExpA" className='error'></span>
        </div> 
        <div className="md-form mb-5">
        <label id="sectionlable">Description</label> 
          <textarea type="text" id="DescriptionExpertiseA"  defaultValue={e.description}/>
          <span id="ExpB" className='error'></span>
        </div> 
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddFirst */}
<div className='tech-pop-fade' id="ExpertiseAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"100px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD EXPERTISE</h4>
        <button type="button" className="close" onClick={closeExpertiseAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecformExpertise" onSubmit={submitsectionExpertise} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
    
          <label id="sectionlable">Image</label>  
 
         <input type="file" onChange={handleFileChangeExpertise}/>
         
         <span id="AddExpA" className='error'></span>
        </div>
        <div className="md-form mb-5">
        <label id="sectionlable">Heading</label> 
          <input type="text" id="textExpertise"/>
          <span id="AddExpB" className='error'></span>
        </div> 
        <div className="md-form mb-5">
           
        <label id="sectionlable"> Description</label> 
          <textarea type="text" id="DescriptionExpertise"/>
          <span id="AddExpC" className='error'></span>
        </div> 
        

        

       
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 
    <div className='tec-sectionMain' id="PopATable">


{/* Table  */}
{
  sectionExpertise.length==0 ? <div id="TecApiFail">" No Data Found "</div>:(<div>
<div className='tectable'>

  <div class="tec-table_responsive">
  {
  !paginatedPosts ? ("No data found"):(
<table>
  <thead>
    <tr>
    <th>Image</th>
      <th>Heading</th>
      <th>Description</th>
      
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPosts.map((e)=>{
    
  
    return<tr>
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td><div style={{inlineSize:"150px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.text}</div></td>
    <td><div style={{inlineSize:"340px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.description}</div></td>
   

   
    <td  style={{whiteSpace:"nowrap"}}>
     {editicon? <span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionExpertise(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
     {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
     {denied?<span className='error'>Denied</span>:null}
    
    </td>
    </tr>
 } )}
  </tbody>
</table>
)}
</div>
</div>
<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      }
        */}
  {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}



</div>
   )}
    </div>
    </div>

    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}


   {/* DeletePopup */}

   {Edittec.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionExpertise(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
  )
}

export default TecExpertiseMain
